import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { DatePicker } from "antd";
import { getApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import CustomSelect from "../../../../../components/Elements/Select/CustomSelect";
import moment from "moment";

const BasicDetailsFormCard = ({
  formId,
  roleType = [],
  formName,
  formAllotmentId,
  isEmployeeRoute: isEmployeeRouteProp,
  selectedSection,
  setSelectedSection,
  endDate,
  setEndDate,
  selectedRole,
  setSelectedRole,
}) => {
  const [sectionList, setSectionList] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);
  const [sectionDropdownOpen, setSectionDropdownOpen] = useState(false);
  const location = useLocation();
  const isEmployeeRoute =
    typeof isEmployeeRouteProp === "boolean"
      ? isEmployeeRouteProp
      : location.pathname.startsWith("/employee");
  // Format role list into { label, value } format
  useEffect(() => {
    if (Array.isArray(roleType)) {
      const formatted = roleType.map((role) => ({
        label: role.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
        value: role,
      }));
      setRoleOptions(formatted);
    }
  }, [JSON.stringify(roleType)]);

  const fetchSections = async (formId, allotmentId) => {
    try {
      // Employee dashboard: avoid hitting client sections API
      if (isEmployeeRoute && !allotmentId) {
        setSectionList([]);
        return;
      }
      const response = await getApi({
        apiUrl:
          isEmployeeRoute && allotmentId
            ? API_URLS.GET_ALLOTTED_SECTIONS(allotmentId)
            : API_URLS.GET_SECTION_BY_FORMID(formId),
      });
      if (response?.success) {
        const rawSections =
          response?.data?.sections ||
          response?.data ||
          response?.data?.data ||
          [];
        const sectionOptions = rawSections.map((section) => ({
          label: section.title || section.name || section.sectionName,
          value: section._id || section.sectionId,
        }));

        setSectionList([
          { label: "Select ALL SECTION", value: "all_section" },
          ...sectionOptions,
        ]);
      }
    } catch (error) {
      console.log("Error fetching sections:", error);
    }
  };

  const handleSelectSection = useCallback(
    (value) => {
      if (value.includes("all_section")) {
        const allValues = sectionList
          .filter((s) => s.value !== "all_section")
          .map((s) => s.value);

        setSelectedSection(allValues);
      } else {
        setSelectedSection(value);
      }

      // Close dropdown after every selection
      setSectionDropdownOpen(false);
    },
    [sectionList, setSelectedSection],
  );
  useEffect(() => {
    fetchSections(formId, formAllotmentId);
    console.log("formId change ho raha hai:", formId);
  }, [formId, formAllotmentId]);

  return (
    <div className="bg-white rounded-xl border border-[#62caae] p-4 sm:p-6 w-full  mx-auto mb-3">
      <h2 className="text-lg sm:text-xl font-semibold text-[#06513D] mb-2">
        {formName}
      </h2>

      <div className="space-y-4">
        {/* First Row - Select Section (Full Width) */}
        <div className="w-full">
          <label className="block mb-1 text-sm text-[#06513D] font-medium">
            SELECT SECTION
          </label>
          <CustomSelect
            options={sectionList}
            mode="multiple"
            height="auto"
            placeholder="Select Section"
            value={selectedSection}
            onChange={handleSelectSection}
            loading={sectionList.length === 0}
            open={sectionDropdownOpen}
            onDropdownVisibleChange={setSectionDropdownOpen}
          />
        </div>

        {/* Second Row - Select Role and End Date */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Role Select */}
          <div>
            <label className="block mb-1 text-sm text-[#06513D] font-medium">
              SELECT ROLE
            </label>
            <CustomSelect
              options={roleOptions}
              height="auto"
              placeholder="Select Role"
              value={selectedRole}
              onChange={(value) => setSelectedRole(value)}
              loading={roleOptions.length === 0}
              // disabled={selectedSection.length === 0}
            />
          </div>

          {/* End Date */}
          <div>
            <label className="block mb-1 text-sm text-[#06513D] font-medium">
              END DATE
            </label>
            <DatePicker
              className="w-full"
              height="auto"
              value={endDate}
              onChange={(date) => setEndDate(date)}
              disabledDate={(current) =>
                current && current < moment().startOf("day")
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicDetailsFormCard;
